"use client";

import {useOrg} from "@/hooks/useOrg";
import {useScriptVersioningFlagState} from "@/hooks/useScriptVersioningEnabled";
import {fetchScriptIdentifiers, toScriptApiVersion} from "@/utils/scriptVersioning/api";
import {createSharedApprovalLookup} from "./createSharedApprovalLookup";

const EMPTY: ReadonlyMap<string, string> = new Map();
const useNames = createSharedApprovalLookup(async key => {
   const [, versioning] = JSON.parse(key) as [string, boolean];
   // Include archived scripts so historical reviews remain identifiable.
   const scripts = await fetchScriptIdentifiers(toScriptApiVersion(versioning));
   if (scripts === null) throw new Error("Failed to load phone script names");
   return new Map(scripts.map(script => [script.id.toLowerCase(), script.name]));
});

/** Display-only names, shared by mounted reviews within one organization and API version. */
export function usePhoneScriptNames(enabled: boolean): ReadonlyMap<string, string> {
   const {org} = useOrg();
   const {ready, enabled: versioning} = useScriptVersioningFlagState();
   return useNames(enabled && ready && org?.id ? JSON.stringify([org.id, versioning]) : null) ?? EMPTY;
}
